<template>
  <div>
    <b-carousel
      :id="carouselId"
      :ref="carouselId"
      :no-animation="noAnimation"
      :indicators="indicators"
      :controls="controls"
      :fade="fade"
      :img-width="imgWidth"
      :img-height="imgHeight"
      :interval="interval"
    >
      <b-carousel-slide :id="mySessions">
        <template #img>
          <my-sessions
            :resource="resource"
            :sessions="mySessions"
            @session-selected="handleSessionSelected"
          />
        </template>
      </b-carousel-slide>
      <b-carousel-slide  :id="sessionsId">
        <template #img>
        </template>
      </b-carousel-slide>
      <b-carousel-slide  :id="sessionsId">
        <template #img>
          <sessions
            :resource="resource"
            :settings="settings"
            :session="selectedSession"
            @go-back="handleGoBack()"
          />
        </template>
      </b-carousel-slide>
      <b-carousel-slide :id="sessionsId">
        <template #img>
          <session
            :resource="resource"
            :settings="settings"
            :session="selectedSession"
            @go-back="handleGoBack()"
          />
        </template>
      </b-carousel-slide>
    </b-carousel>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import MySessions from "./mySessions";
import Sessions from "./sessions";
import Session from "./session";
import sessionsDataJSON from "../../../assets/json/sessionsData.json";
export default {
  name: "Display_Sessions_NavSlideView",
  components: {
    MySessions,
    Session,
    Sessions
  },
  props: {
    resource: {
      type: Object,
      required: () => {
        return {};
      }
    },
    settings: {
      type: Object,
      required: () => {
        return {};
      }
    }
  },
  created() {},
  mounted() {},
  computed: {
    ...mapGetters({
      profile: "user/profile",
      userData: "user/appsData"
    }),
    /* SETTINGS */
    /* USER DATA */
    userDataBends() {
      return this.userData &&
        this.userData &&
        this.userData[`app_${this.resource.toolId}`] &&
        this.userData[`app_${this.resource.toolId}`].bends
        ? this.userData[`app_${this.resource.toolId}`].bends
        : [];
    },
    formSolitude() {
      return this.form;
    }
  },
  methods: {
    handleGoToSlide(isNext) {
      if (isNext) {
        this.$refs[this.carouselId].next();
      }
    },
    handleGoBack() {
      this.$refs[this.carouselId].prev();
    },
    handleAnswerClick(key, value) {
      this.form[key] = value;
      this.handleGoToSlide(true);
    },
    handleSessionSelected(session) {
      this.selectedSession = session;
      this.handleGoToSlide(true);
    }
  },
  data() {
    return {
      sessionsId:"sessions-id",
      selectedSession: null,
      mySessions: sessionsDataJSON["my_session"].sessions, //placeholder
      sessionsDataJSON,
      form: {},
      formDefault: {
        _started_at: null,
        get_away_time: null,
        go_where_place: null,
        go_do_activity: null
      },
      /* SLIDE INFO*/
      viewHeight: 250,
      carouselId: "solitude-views",
      controls: false,
      noAnimation: true,
      indicators: false,
      fade: false,
      slide: 0,
      sliding: null,
      imgWidth: "1024",
      imgHeight: "100vh",
      interval: 0,
      mainProps: {
        blank: false,
        blankColor: "#777",
        width: 50,
        height: 50,
        class: "m1"
      }
    };
  }
};
</script>

<style lang="scss" scoped></style>
